import React, { useState } from 'react';
import { useInstallState, promptInstall } from '../lib/pwa';

// "Install app" control. On Chrome/Edge (phone or PC) it opens the native
// install dialog; on iPhone/iPad it explains Share → Add to Home Screen.
// Renders nothing once the app is installed or when the browser can't install.
export default function InstallApp({ variant = 'sidebar' }) {
  const state = useInstallState();
  const [showIOSHelp, setShowIOSHelp] = useState(false);
  if (!state) return null;

  if (variant === 'login') {
    return (
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        {state === 'prompt' ? (
          <button type="button" onClick={promptInstall} style={{ background: 'none', border: '1px solid rgba(13,22,38,0.12)', borderRadius: 9, padding: '8px 14px', fontFamily: 'Plus Jakarta Sans,sans-serif', fontSize: 13.5, fontWeight: 700, color: 'var(--navy)', cursor: 'pointer' }}>
            ⬇ Install the app on this device
          </button>
        ) : (
          <div style={{ fontSize: 12.5, color: 'var(--slate)', lineHeight: 1.5 }}>
            Install on iPhone/iPad: tap <strong>Share</strong> then <strong>Add to Home Screen</strong>.
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <button
        className="sb-so sb-install"
        title="Install this app on your device"
        onClick={() => (state === 'prompt' ? promptInstall() : setShowIOSHelp(v => !v))}
      >
        ⬇<span className="sb-install-label"> Install App</span>
      </button>
      {showIOSHelp && (
        <div className="sb-install-help">Tap <strong>Share</strong>, then <strong>Add to Home Screen</strong>.</div>
      )}
    </>
  );
}
